export default class Vehicle {
  constructor(
    vehicleData,
    ncdDetails,
    otherNcdDetails,
    garageAddress,
    securityDevices,
    modifications
  ) {
    this.abiCode = vehicleData.abiCode || "0";
    this.annualMileage = vehicleData.annualMileage || 0;
    this.bodyTypeId = vehicleData.bodyTypeId;
    this.businessMileage = vehicleData.businessMileage || 0;
    this.cctv = vehicleData.cctv || false;
    this.colourId = vehicleData.colourId || null;
    this.countryOfFirstRegistrationId =
      vehicleData.countryOfFirstRegistrationId || "0";
    this.coverTypeId = vehicleData.coverTypeId;
    this.cubicCapacity = vehicleData.cubicCapacity;
    this.currentMileage = vehicleData.currentMileage || 0;
    this.estimatedValue = vehicleData.estimatedValue;
    this.exteriorCameraDetails = vehicleData.exteriorCameraDetails;
    this.fuelTypeId = vehicleData.fuelTypeId;
    this.garageAddress = garageAddress;
    this.gearboxId = vehicleData.gearboxId;
    this.gvw = vehicleData.gvw;
    this.hackneyCarriage = vehicleData.hackneyCarriage || false;
    this.havePreviousRegistration = vehicleData.havePreviousRegistration;
    this.imported = vehicleData.imported;
    this.interiorCamera = vehicleData.interiorCamera;
    this.keeperId = vehicleData.keeperId;
    this.licensingPlateNumber = vehicleData.licensingPlateNumber;
    this.make = vehicleData.make;
    this.model = vehicleData.model;
    this.ncdDetails = ncdDetails;
    this.noOfSeats = vehicleData.noOfSeats;
    this.objectId = vehicleData.objectId;
    this.operatingArea = vehicleData.operatingArea;
    this.operatingPostcode = vehicleData.operatingPostcode || null;
    this.otherNcdDetails = otherNcdDetails || null;
    this.overnightParkingId = vehicleData.overnightParkingId || null;
    this.ownerId = vehicleData.ownerId;
    this.parentObjectHistoryId = vehicleData.parentObjectHistoryId;
    this.parentObjectId = vehicleData.parentObjectId;
    this.permanentReferenceNumber = vehicleData.permanentReferenceNumber;
    this.personalisedPlate = vehicleData.personalisedPlate;
    this.preVehicleSearch = vehicleData.preVehicleSearch;
    this.preVehicleSearchSuccess = vehicleData.preVehicleSearchSuccess;
    this.PreviousVehicleAbicode = vehicleData.PreviousVehicleAbicode;
    this.PreviousVehicleMake = vehicleData.PreviousVehicleMake;
    this.PreviousVehicleModel = vehicleData.PreviousVehicleModel;
    this.PreviousVehicleYOM = vehicleData.PreviousVehicleYOM;
    this.previousVehicleOwned12Month = vehicleData.previousVehicleOwned12Month;
    this.previousVehicleRegistrationNumber =
      vehicleData.previousVehicleRegistrationNumber;
    this.pricePaid = vehicleData.pricePaid;
    this.purchaseDate = vehicleData.purchaseDate;
    this.qPlated = vehicleData.qPlated;
    this.qPlatedReasonId = vehicleData.qPlatedReasonId;
    this.registeredDate = vehicleData.registeredDate;
    this.registrationNumber = vehicleData.registrationNumber;
    this.rightHandDrive = vehicleData.rightHandDrive;
    this.securityDevices = securityDevices;
    this.selfModified = vehicleData.selfModified;
    this.modifications = modifications;
    this.series = vehicleData.series;
    this.uberVehicleId = vehicleData.uberVehicleId;
    this.usedForContractWork = vehicleData.usedForContractWork;
    this.valueReasonId = vehicleData.valueReasonId;
    this.vehicleGrouping = vehicleData.vehicleGrouping;
    this.yearOfManufacture = vehicleData.yearOfManufacture || 1899;
  }
}
